import { render, staticRenderFns } from "./OrderRoom.vue?vue&type=template&id=4bff7c3d&scoped=true&"
import script from "./OrderRoom.vue?vue&type=script&lang=js&"
export * from "./OrderRoom.vue?vue&type=script&lang=js&"
import style0 from "./OrderRoom.vue?vue&type=style&index=0&id=4bff7c3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bff7c3d",
  null
  
)

export default component.exports